import React from 'react';
import { Zap, Car } from 'lucide-react';
import { Button } from './ui/button';

const EVChargerBanner = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-8 sm:py-12 relative overflow-hidden" style={{ backgroundColor: '#3a2a23' }}>
      {/* Subtle animated line */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
        <svg className="absolute w-full h-full" viewBox="0 0 1920 200" preserveAspectRatio="none">
          <defs>
            <linearGradient id="evBannerGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="transparent">
                <animate attributeName="offset" values="0;1" dur="3s" repeatCount="indefinite"/>
              </stop>
              <stop offset="20%" stopColor="#d4c19c">
                <animate attributeName="offset" values="0.2;1.2" dur="3s" repeatCount="indefinite"/>
              </stop>
              <stop offset="40%" stopColor="transparent">
                <animate attributeName="offset" values="0.4;1.4" dur="3s" repeatCount="indefinite"/>
              </stop>
            </linearGradient>
          </defs>
          <path d="M0,100 Q480,80 960,100 T1920,100" fill="none" stroke="url(#evBannerGradient)" strokeWidth="2"/>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
          {/* Left - Icon & Text */}
          <div className="flex items-center gap-3 sm:gap-4 text-center sm:text-left">
            {/* Hexagonal Icon */}
            <div 
              className="w-12 h-12 sm:w-14 sm:h-14 relative flex-shrink-0 flex items-center justify-center"
              style={{
                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                backgroundColor: '#d4c19c'
              }}
            >
              <div 
                className="absolute inset-[2px] flex items-center justify-center"
                style={{
                  clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                  backgroundColor: '#3a2a23'
                }}
              >
                <Car className="w-5 h-5 sm:w-6 sm:h-6" style={{ color: '#d4c19c' }} />
              </div>
            </div>
            
            <div>
              <h3 className="text-lg sm:text-xl font-bold" style={{ color: '#d4c19c' }}>
                Future-Ready Homes
              </h3>
              <p className="text-sm sm:text-base" style={{ color: '#9c7c5e' }}>
                Professional EV Charger Installation
              </p>
            </div>
          </div>

          {/* Right - CTA */}
          <Button 
            onClick={scrollToContact}
            className="font-semibold px-6 py-5 rounded-lg transition-all duration-300 hover:scale-105 w-full sm:w-auto"
            style={{ 
              backgroundColor: '#d4c19c', 
              color: '#2a1f1a'
            }}
          >
            <Zap className="w-4 h-4 mr-2" />
            Get EV Charger Quote
          </Button>
        </div>
      </div>
    </section>
  );
};

export default EVChargerBanner;
